import React from "react"

// import Auth from "auth";
import { API } from "API"
import { ErrorsCallback, SuccessConfirm } from "alertService"
import * as Alert from "alertService"
import { compose } from "recompose"
import { connect } from "react-redux"

// @material-ui/core components =====
import withStyles from "@material-ui/core/styles/withStyles"

// @material-ui/icons =====
import AddCircleIcon from "@material-ui/icons/AddCircle";
import FormatListNumberedIcon from "@material-ui/icons/FormatListNumbered";
import EditIcon from "@material-ui/icons/Edit";
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';

import { listsThemeSMSUpdate } from "store/actions"

// core components =====
import GridContainer from "components/Grid/GridContainer"
import GridItem from "components/Grid/GridItem"
import NavPills from "components/NavPills/NavPills";

// ComponentsPage =====
import ListsPage from "./Lists";
import CreatePage from "./Create";

import { cardTitle } from "assets/jss/material-dashboard-pro-react"
// import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle"
const styles = {
  ...regularFormsStyle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  mt4: {
    marginTop: "30px"
  },
  titleIcon: {
    marginBottom: -7

  }
}
class ProjectManagementPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      currentPage: 0,
      currentData: null,
    }
  }
  componentDidUpdate(prevProps, prevState) {
    console.log("prevState >>", prevState)
  }

  componentDidMount() {
    Alert.Loading(true)
  }
  setTabIndex = (index, data) => {
    if (index == 1) {
      this.setState({ currentPage: index, currentData: data })
    } else if (index == 0) {
      this.setState({ currentPage: index, currentData: null })
    }
  }
  getTabIndex = (index) => {
    // if (index == 0) {
    //   this.setState({ currentPage: index, currentData: null })
    // }
  }
  setcurrentData = (dataObject) => {
    this.setState({ currentData: dataObject })
  }
  render() {
    const { classes } = this.props 
    return (
      <GridContainer>
        <GridItem xs={12}>
          <NavPills
            onChangeTabIndex={this.getTabIndex}
            color="info"
            active={this.state.currentPage}
            tabs={[
              {
                // <GroupIcon className={classes.titleIcon} /> 
                tabIcon: FormatListNumberedIcon,
                tabButton: "รายการ",
                tabContent: <ListsPage
                  callbacksetTabIndex={this.setTabIndex}
                  callbackSetCurrentData={this.setcurrentData}
                />
              },
              {
                tabIcon: LibraryBooksIcon,
                tabButton: (this.state.currentData ? "แก้ไขรูปแบบ SMS" : "สร้างรูปแบบ SMS"),
                tabContent: <CreatePage
                  currentData={this.state.currentData}
                  callbacksetTabIndex={this.setTabIndex}
                />
              }
            ]}
          />
        </GridItem>
      </GridContainer>
    )
  }
}
function mapStateToProps({ listsThemeSMS }) {
  return {
    listsThemeSMS: listsThemeSMS
  }
}

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    { listsThemeSMSUpdate }
  )
)(ProjectManagementPage) 
